import './src/vaadin-card.js';

export * from './src/vaadin-card.js';
